const MESES = {
  "01": "Enero",
  "02": "Febrero",
  "03": "Marzo",
  "04": "Abril",
  "05": "Mayo",
  "06": "Junio",
  "07": "Julio",
  "08": "Agosto",
  "09": "Septiembre",
  "10": "Octubre",
  "11": "Noviembre",
  "12": "Diciembre",
};

const nombreMes = (mes) =>
  MESES[mes?.toString().padStart(2, "0")] || mes;

export function analizarMunicipios(filas) {
  const porMunicipio = {};

  // ===============================
  // AGRUPAR POR MUNICIPIO
  // ===============================
  filas.forEach((f) => {
    if (!porMunicipio[f.municipio]) {
      porMunicipio[f.municipio] = [];
    }
    porMunicipio[f.municipio].push(f);
  });

  return Object.entries(porMunicipio).map(([municipio, datos]) => {
    const ordenados = [...datos].sort((a, b) =>
      a.mes.localeCompare(b.mes)
    );

    const mesesEnRojoArr = ordenados.filter(
      (m) => m.semaforo === "ROJO"
    );

    const mesesEnRojo = mesesEnRojoArr.length;

    const mejor = ordenados.reduce((a, b) =>
      b.variacion > a.variacion ? b : a
    );

    const peor = ordenados.reduce((a, b) =>
      b.variacion < a.variacion ? b : a
    );

    // ===============================
    // DETECTAR CAÍDA SOSTENIDA REAL
    // ===============================
    let caidaSostenida = false;
    let inicioCaida = null;

    for (let i = 0; i < ordenados.length - 1; i++) {
      if (
        ordenados[i].semaforo === "ROJO" &&
        ordenados[i + 1].semaforo === "ROJO"
      ) {
        caidaSostenida = true;
        inicioCaida = ordenados[i].mes;
        break;
      }
    }

    // ===============================
    // ETIQUETA EJECUTIVA
    // ===============================
    let etiqueta = "⚪ Comportamiento estable";
    let tendencia = "ESTABLE";

    if (caidaSostenida) {
      etiqueta = "🔴 Riesgo alto";
      tendencia = "DECRECIENTE";
    } else if (mesesEnRojo === 1) {
      etiqueta = "🟠 Alerta";
    } else if (mejor.variacion >= 20) {
      etiqueta = "🟢 Recuperación";
      tendencia = "CRECIENTE";
    }

    // ===============================
    // INSIGHT INTELIGENTE
    // ===============================
    let insight = `${municipio} mantiene un comportamiento estable sin variaciones críticas. Se recomienda monitoreo continuo.`;

    if (caidaSostenida) {
      insight = `${municipio} presenta una caída sostenida desde el mes ${nombreMes(
        inicioCaida
      )}. Se recomienda reforzar estrategias operativas y campañas focalizadas.`;
    } else if (mejor.variacion >= 20) {
      insight = `${municipio} muestra una recuperación relevante a partir de ${nombreMes(
        mejor.mes
      )} con un crecimiento máximo de ${mejor.variacion}%. Se recomienda consolidar la estrategia operativa actual.`;
    } else if (mesesEnRojo === 1) {
      insight = `${municipio} presenta una variación negativa puntual en ${nombreMes(
        peor.mes
      )}. Se recomienda monitoreo preventivo.`;
    }

    // ===============================
    // RESPUESTA FINAL (COMPATIBLE)
    // ===============================
    return {
      municipio,
      insight,
      etiqueta,
      tendencia,

      // 👇 ESTA FRANJA VUELVE A FUNCIONAR
      mejorMes: nombreMes(mejor.mes),
      peorMes: nombreMes(peor.mes),
      mesesEnRojo,
    };
  });
}
